import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WHS_REQUEST = 'GET_WHS_REQUEST';
export const GET_WHS_SUCCESS = 'GET_WHS_SUCCESS';
export const GET_WHS_FAILURE = 'GET_WHS_FAILURE';
export const NEW_WHS_GRID_CRITERIA = 'NEW_WHS_GRID_CRITERIA';
export const GET_LINKED_ACCOUNTS_REQUEST = 'GET_LINKED_ACCOUNTS_REQUEST';
export const GET_LINKED_ACCOUNTS_SUCCESS = 'GET_LINKED_ACCOUNTS_SUCCESS';
export const GET_LINKED_ACCOUNTS_FAILURE = 'GET_LINKED_ACCOUNTS_FAILURE';
export const CLOSE_LINKED_ACCOUNTS_MODAL = 'CLOSE_LINKED_ACCOUNTS_MODAL';

export function newGridCriteria(gridCriteria) {
  return {
    type: NEW_WHS_GRID_CRITERIA,
    gridCriteria
  };
}

function requestGetWhdStatements() {
  return {
    type: GET_WHS_REQUEST,
    loading: true
  };
}

function receiveGetWhdStatements(data) {
  return {
    type: GET_WHS_SUCCESS,
    loading: false,
    data,
    error: ''
  };
}

function rejectGetWhdStatements(error) {
  return {
    type: GET_WHS_FAILURE,
    loading: false,
    data: [],
    error: ''
  };
}

function requestLinkedAccounts() {
  return {
    type: GET_LINKED_ACCOUNTS_REQUEST,
    isGettingLinkedAccounts: true
  };
}

function receiveLinkedAccounts(linkedAccounts) {
  return {
    type: GET_LINKED_ACCOUNTS_SUCCESS,
    isGettingLinkedAccounts: false,
    linkedAccounts,
    error: ''
  };
}

function rejectLinkedAccounts(error) {
  return {
    type: GET_LINKED_ACCOUNTS_FAILURE,
    isGettingLinkedAccounts: false,
    linkedAccounts: [],
    error
  };
}

function closeModal() {
  return {
    type: CLOSE_LINKED_ACCOUNTS_MODAL,
  };
}

export function getWhdStatements(
  pageNumber,
  pageSize,
  sortBy,
  sortDirection,
  filters,
  activeTab,
  asOfDate,
  processDataFunc
) {
  return (dispatch) => {
    dispatch(requestGetWhdStatements());

    const promise = () => ApiService
      .getWithholdingStatements(
        pageNumber,
        pageSize,
        sortBy,
        sortDirection,
        filters,
        activeTab,
        asOfDate?.toLocaleString('en-us', { month: 'short', day: 'numeric', year: 'numeric' }).replace(/[^ -~]/g, '')
      )
      .then((response) => {
        const processedData = processDataFunc(response.data);
        dispatch(receiveGetWhdStatements(processedData));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(rejectGetWhdStatements(error.response));
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}

export function getLinkedAccounts(accountId) {
  return (dispatch) => {
    dispatch(requestLinkedAccounts());

    const promise = () => ApiService
      .getLinkedAccounts(accountId)
      .then((response) => {
        dispatch(receiveLinkedAccounts(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(rejectLinkedAccounts(error.response));
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}

export function closeLinkedAccountsModal() {
  return dispatch => dispatch(closeModal());
}
